import { supabase } from '@/integrations/supabase/client';

/**
 * Start the signed-in user's one-time 7-day Pro trial. The server
 * (`start_trial()`, fl-itn) sets the dates, acts only on the caller's own
 * profile, and refuses a second trial; the client can no longer write the
 * trial columns directly. Returns the trial expiry (ISO timestamp).
 */
export async function activateTrial(): Promise<string> {
  const { data, error } = await supabase.rpc('start_trial');
  if (error) throw new Error(error.message || 'Could not start the trial');
  return data;
}
